import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../components/animation/loading";
import BannerModal from "../../../components/Settings/Banner/modal/BannerModal";
import { BannerCard } from "../../../components/Settings/Banner/BannerCard";
import useBanner from "../../../hooks/useBanner";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useSelector } from "react-redux";

export default function Banners() {
  const [openBanner, setOpenBanner] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [banners, setBanners] = useState([]);
  const { banners } = useSelector((state) => state.bannerSettings);

  const [triggerFetchBanner, setTriggerFetchBanner] = useState(0);
  const { getBanners, getBannersByLocation, getLocations } = useBanner();
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [loadingToFetchLocation, setLoadingToFetchLocation] = useState(false);
  const [locationDatas, setLocationDatas] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Only fetch all banners if no product is selected
        if (!selectedProduct) {
          await getBanners(setLoading);
        } else {
          // Fetch filtered banners based on product and location
          if (selectedProduct && !selectedLocation) {
            await getBannersByLocation(setLoading, selectedProduct);
          }

          if (selectedProduct && selectedLocation) {
            await getBannersByLocation(
              setLoading,
              selectedProduct,
              selectedLocation
            );
          }
        }

        // Fetch locations (only needed once, but will refresh on triggerFetchBanner)
        const responseLocations = await getLocations(setLoadingToFetchLocation);
        if (responseLocations) {
          setLocationDatas(responseLocations);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [triggerFetchBanner, selectedProduct, selectedLocation]);

  function filterByProduct(data, product) {
    if (!Array.isArray(data)) {
      console.error("Expected an array of data");
      return [];
    }

    const filtered = data.filter(
      (item) => item.product?.toLowerCase() === product.toLowerCase()
    );

    return filtered;
  }

  const filteredLocations = filterByProduct(locationDatas, selectedProduct);
  const locationOptions = filteredLocations.map((item) => item.location);

  return (
    <>
      <div className=" flex flex-col space-y-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4">
            <Dropdown
              label="Select product"
              options={["flight", "hotel", "tour"]}
              handleClick={(value) => setSelectedProduct(value)}
            />

            <Dropdown
              label="Select location"
              options={locationOptions}
              handleClick={(value) => setSelectedLocation(value)}
            />

            <button
              onClick={() => {
                setSelectedProduct("");
                setSelectedLocation("");
              }}
              className="px-4 py-2 text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 rounded-lg transition-colors duration-200"
            >
              Clear Filter
            </button>
          </div>

          <button
            onClick={() => setOpenBanner(true)}
            className="bg-theme1 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            Add Banner
          </button>
        </div>
        {/* <hr className="border-b border-gray-200" /> */}
        {loading ? (
          <div className="flex justify-center items-center">
            <Loading />
          </div>
        ) : banners.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {banners?.map((banner) => (
              <BannerCard
                triggerFetchBanner={() => setTriggerFetchBanner((t) => t + 1)}
                key={banner._id}
                banner={banner}
              />
            ))}
          </div>
        ) : (
          <div className="flex justify-center">No Banners found</div>
        )}
      </div>

      {openBanner && (
        <BannerModal
          onTrigger={() => setTriggerFetchBanner((t) => t + 1)}
          setOpenBanner={setOpenBanner}
        />
      )}
    </>
  );
}

const Dropdown = ({ label, options = [], handleClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(label);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
    handleClick(option);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-52" ref={dropdownRef}>
      <button
        onClick={() => options.length > 0 && setIsOpen(!isOpen)}
        disabled={options.length === 0}
        className={`w-full bg-white border rounded-md shadow-sm px-4 py-2 text-sm text-gray-700 flex justify-between items-center hover:border-gray-400 focus:outline-none
          ${
            options.length === 0
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "border-gray-300"
          }
        `}
      >
        {selected}
        <KeyboardArrowDownIcon
          className={`text-gray-500 transform transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
          fontSize="small"
        />
      </button>

      {isOpen && options.length > 0 && (
        <ul className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg">
          {options.map((option) => (
            <li
              key={option}
              onClick={() => handleSelect(option)}
              className="px-4 py-2 text-gray-700 text-sm hover:bg-gray-100 cursor-pointer"
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
